const state = {
  group: {},
  company: {},
  products: null,
  product: {}
}

export default state
